import React from "react";
import createReactClass from "create-react-class";

import AlbumDeletebutton from "./album_delete_button";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      photoUrl: "",
    };
  },
  componentDidMount() {
    var url = this.props.album["top_photo_url"]
      ? this.props.album["top_photo_url"]
      : "/images/ja2/img_noimage.gif";
    this.setState({
      photoUrl: url,
    });
  },
  onError() {
    this.setState({
      photoUrl: "/images/ja2/img_noimage.gif",
    });
  },
  handleAlbumClicked() {
    window.location.href =
      "/circle/" + this.props.circleId + "/album/" + this.props.albumId;
  },
  render() {
    var photoDirection = this.props.album["top_photo_is_wide"]
      ? "photo-w"
      : "photo-h";
    var albumTitle = this.props.album["album_title"]
      ? this.props.album["album_title"]
      : "無題のアルバム";
    return (
      <li className="col-md-3 col-sm-3 col-xs-4 my-3 p-0">
        <div className="album-list-item" style={{ paddingBottom: '8px' }}>
          <div className="album-list" data-cat="1">
            <a className="album-top-photo-wrap">
              <AlbumDeletebutton
                albumId={this.props.albumId}
                isActive={this.props.isDeleteMode}
                albumSelected={this.props.albumSelected}
              />
              <img
                className={photoDirection}
                src={this.state.photoUrl}
                onClick={this.handleAlbumClicked}
                onError={this.onError}
              />
            </a>
          </div>
          <a className="album-info" onClick={this.handleAlbumClicked}>
            <p className="mx-2 my-0 text-fw-bold">{albumTitle}</p>
            <p className="mx-2 my-0">
              <span
                className="small"
                style={{ color: "#969696" }}
              >
                {this.props.album["photo_count"]}
              </span>
              <span
                className="label"
                style={{
                  float: "right",
                  opacity: "0.7",
                  paddingRight: "6px",
                  color: this.props.publicTypeData[this.props.album.public_type]
                    .color,
                }}
              >
                <i
                  className={
                    this.props.publicTypeData[this.props.album.public_type].icon
                  }
                  aria-hidden="true"
                />
              </span>
            </p>
          </a>
        </div>
      </li>
    );
  },
});
